import { navigate } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import * as React from "react"
import Layout from "../components/layout"
import Footer from "../components/section/Layout/Footer"
import Seo from "../components/seo"

export default function IndexPage() {
  return (
    <Layout noHeader={true} noFooter={true}>
      <Seo title="Home" />
      <section className="min-h-screen flex items-center justify-center gap-8 flex-col">
        <StaticImage
          alt="logo"
          src="../images/I-ALIGN MONO CLEAN.png"
          className="w-64"
        />
        <div className="max-w-sm text-center relative -mt-12">
          <h1 className="uppercase font-bold text-primary-500">
            innovative Programs that sky-rockets your personal and business
            growth
          </h1>
        </div>
        <button
          onClick={() => {
            navigate("/landing/program/retreat1/")
          }}
          className="px-10 py-4 rounded-md bg-primary-600 text-white text-sm outline-none focus:outline-none"
        >
          Check out our 2022 program
        </button>
      </section>
      <Footer />
    </Layout>
  )
}
